import { render, staticRenderFns } from "./Thumbnail.component.vue?vue&type=template&id=961bd006&scoped=true&"
import script from "./Thumbnail.component.vue?vue&type=script&lang=ts&"
export * from "./Thumbnail.component.vue?vue&type=script&lang=ts&"
import style0 from "./Thumbnail.component.vue?vue&type=style&index=0&id=961bd006&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961bd006",
  null
  
)

export default component.exports